import IntlMessageFormat from 'intl-messageformat';
import _format from 'date-fns/format';

export const CURRENCY = __('formatting.currencyIso') || 'EUR';

export const LOCALE = __LOCALE__;
const LANGUAGE = __LANGUAGE__;

const stringFormatter = (message) =>
  new IntlMessageFormat(message, LOCALE).format;

const formatMarkdown = (message) => {
  return message.replace(/\*\*([a-zA-Z0-9\s]+)\*\*/, '<strong>$1</strong>');
};

const numberFormat = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  style: 'decimal',
});

const moneyFormat = new Intl.NumberFormat(LANGUAGE, {
  currency: CURRENCY,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  style: 'currency',
});

const fuelConsumptionFormat = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
  style: 'decimal',
});

const formatters = {
  distanceKm: stringFormatter(__('distance.km')),
  powerHp: stringFormatter(__('power.hp')),
  powerKw: stringFormatter(__('power.kw')),
};

const formatNumber = numberFormat.format;
const formatMoney = moneyFormat.format;
const formatFuelConsumption = fuelConsumptionFormat.format;

const formatPower = ({ hp, kw }) => {
  if (hp !== undefined) {
    hp = formatters.powerHp({ power: formatNumber(hp) });
  }

  if (kw !== undefined) {
    kw = formatters.powerKw({ power: formatNumber(kw) });
  }

  if (kw && hp) {
    return `${kw} (${hp})`;
  } else if (kw) {
    return kw;
  } else if (hp) {
    return hp;
  }
};

const formatDistance = (num) =>
  formatters.distanceKm({ distance: formatNumber(num) });

export {
  formatDistance,
  formatFuelConsumption,
  formatMarkdown,
  formatMoney,
  formatNumber,
  formatPower,
  stringFormatter,
};
